// Tiny browser accessors shared by the appVersion runtime modules.

/** The compiled build id (vite define), falling back to the index.html meta tag. */
export function getCurrentBuildId(): string {
  try {
    if (typeof __APP_BUILD_ID__ === "string" && __APP_BUILD_ID__) return __APP_BUILD_ID__;
  } catch {
    // not defined (unit tests) — fall through to the meta tag
  }
  if (typeof document !== "undefined") {
    const content = document.querySelector('meta[name="app-build-id"]')?.getAttribute("content");
    if (content) return content;
  }
  return "";
}

/** sessionStorage, or null when access throws (disabled storage, sandboxed frame). */
export function safeSessionStorage(): Storage | null {
  try {
    return typeof window !== "undefined" ? window.sessionStorage : null;
  } catch {
    return null;
  }
}
